module.exports = {"TXTWCL_Today":{"id":"TXTWCL_Today","defaultMessage":"本日"},"TXTWCL_Tomorrow":{"id":"TXTWCL_Tomorrow","defaultMessage":"明日"}}